export default __webpack_public_path__ + "static/media/pauseIcon.691a96d1.svg";